import { render } from "./adminlist.vue?vue&type=template&id=1078d03a&scoped=true&ts=true"
import script from "./adminlist.vue?vue&type=script&lang=ts"
export * from "./adminlist.vue?vue&type=script&lang=ts"

import "./adminlist.vue?vue&type=style&index=0&id=1078d03a&lang=scss&scoped=true"
import "./adminlist.vue?vue&type=style&index=1&id=1078d03a&lang=scss"
import "./adminlist.vue?vue&type=style&index=2&id=1078d03a&lang=scss"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1078d03a"]])

export default __exports__